import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { ButtonUiState } from '../Button/ButtonUi';

export function ConfirmationDialog(props: {
  open: boolean;
  title?: string;
  message?: string;
  okButton?: ButtonUiState;
  onOkButtonListener?: () => void;
  koButton?: ButtonUiState;
  onKoButtonListener?: () => void;
  cancelable?: boolean;
}) {
  return (
    <Dialog
      onClose={props.onKoButtonListener}
      open={props.open}
      PaperProps={{ style: { width: 400 } }}
    >
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.koButton && (
          <Button
            variant={props.koButton.variant}
            onClick={props.onKoButtonListener}
            loading={props.koButton.loading}
            disabled={props.koButton.disabled}
            loadingPosition="start"
          >
            {props.koButton.label}
          </Button>
        )}
        {props.okButton && (
          <Button
            variant={props.okButton.variant}
            onClick={props.onOkButtonListener}
            color="error"
            loading={props.okButton.loading}
            disabled={props.okButton.disabled}
            loadingPosition="start"
          >
            {props.okButton.label}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
